const sort = {
  published: ({ ascending }) => `document.first_publication_date${(ascending) ? '' : ' desc'}`,
  updated: ({ ascending }) => `document.last_publication_date${(ascending) ? '' : ' desc'}`,
  field: ({ type, field, ascending }) => `my.${type}.${field}${(ascending) ? '' : ' desc'}`
}

// pass query directives as arguments
// return object exposes a sorting method
export default function(...queries) {
  return {
    q: `[${queries.join(' ')}]`,
    sort(...sorts) {
      return {
        orderings: `[${sorts.map(order => sort[order.by](order)).join(', ')}]`,
        ...this
      }
    },
    reduce() {
      delete this.sort
      delete this.reduce
      return this
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/query.js